<template>
  <div />
</template>
<script>
export default {
  name: 'JsonLdFaq',
  props: {
    faqItems: { type: Array, default: () => [], required: true },
  },
  jsonld() {
    if (!this.faqItems.length) {
      return null
    }

    const jsonld = {
      '@context': 'http://schema.org',
      '@type': 'FAQPage',
    }

    jsonld.mainEntity = this.faqItems.map(faq => {
      return {
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      }
    })

    return jsonld
  },
}
</script>
